import React, {useCallback, useRef, useState} from 'react';
import {IconButton, WithTooltip} from '@albert-io/atomic';

import {IssuesModal} from './IssuesModal';

interface Props {
  questionId: string;
}

export const IssuesModalButton = ({questionId}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const tooltip = useRef<WithTooltip | null>(null);

  const onClick = useCallback(() => {
    if (tooltip.current) {
      tooltip.current.deactivate();
    }
    setIsOpen(true);
  }, [setIsOpen]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <>
      <WithTooltip ref={tooltip} content='Question Feedback'>
        <IconButton
          icon={['far', 'message-question']}
          onClick={onClick}
          label='Question Feedback'
        />
      </WithTooltip>
      {isOpen && <IssuesModal questionId={questionId} handleClose={handleClose} />}
    </>
  );
};
